import { Item } from "./Item";

export class NavBack extends Item {
}
